import React from 'react'

import { bool, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

function Header({ isSignup, locale = 'en' }) {
  const t = key => i18n.t(`auth_modal.header.${key}`, { ns: 'rails', lng: locale })
  const title = isSignup ? t('signup_title') : t('login_title')

  return (
    <div className="auth-modal__header-group auth-modal__header-group--center">
      <p className="auth-modal__title cgt-heading-300">{title}</p>
      {!isSignup && (
        <p className="auth-modal__subtitle cgt-body-md">{t('login_subtitle')}</p>
      )}
    </div>
  )
}

Header.propTypes = {
  isSignup: bool.isRequired,
  locale: string,
}

export default Header
